import React from "react";

import { Icon } from "../types";

const ProductionIcon: React.FC<Icon> = ({ color, width, height, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill={color}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 15H0V3.75H3.125V9.375L7.5 5.625V7.94L6.3575 8.89563L6.75875 9.375L8.86312 7.61437L11.25 5.625V7.94563L10.115 8.89563L10.5156 9.375L13.3919 6.96875L13.39 6.96625L15 5.625V15ZM3.75 11.25H2.5V13.125H3.75V11.25ZM10 11.25H8.75V13.125H10V11.25ZM6.875 11.25H5.625V13.125H6.875V11.25ZM13.125 11.25H11.875V13.125H13.125V11.25ZM1.875 3.125H1.25C1.37375 1.76125 2.36562 0.625 3.4375 0.625C3.59125 0.625 3.73625 0.661875 3.86438 0.7275C4.06188 0.298125 4.49625 0 5 0C5.50375 0 5.93813 0.298125 6.13563 0.7275C6.26375 0.661875 6.40875 0.625 6.5625 0.625C7.08 0.625 7.5 1.045 7.5 1.5625C7.5 2.08 7.08 2.5 6.5625 2.5C6.40875 2.5 6.26375 2.46312 6.13563 2.3975C5.93813 2.82687 5.50375 3.125 5 3.125C3.53437 3.125 2.67375 1.28062 1.875 3.125Z"
      fill={color}
    />
  </svg>
);
export default ProductionIcon;
